module.exports = __webpack_public_path__ + "img/9791186009628.d5ec048d.jpg";